import { AbstractService } from "./ApiClient";
import { ApiRoutes } from "@typingsGenerator/ApiRoutes";
import ApiKeyListDto = Cloud.RavenDB.Core.Dto.Users.ApiKeyListDto;
import CreateApiKeyDto = Cloud.RavenDB.Core.Dto.ApiKeys.CreateApiKeyDto;
import ApiKeyCreatedDto = Cloud.RavenDB.Core.Dto.ApiKeys.ApiKeyCreatedDto;
import ModifyApiKeyDto = Cloud.RavenDB.Core.Dto.ApiKeys.ModifyApiKeyDto;

export class ApiKeysService extends AbstractService {
    getApiKeys = async (domainName: string): Promise<ApiKeyListDto> => {
        const response = await this.query<ApiKeyListDto>(ApiRoutes.apiKey.getApiKeys({ domainName }));
        return response.data;
    };

    createApiKey = async (dto: CreateApiKeyDto): Promise<ApiKeyCreatedDto> => {
        const response = await this.post<CreateApiKeyDto, ApiKeyCreatedDto>(ApiRoutes.apiKey.createApiKey(), dto);

        return response.data;
    };

    modifyApiKey = async (dto: ModifyApiKeyDto): Promise<void> => {
        await this.post<ModifyApiKeyDto, void>(ApiRoutes.apiKey.modifyApiKey(), dto);
    };

    deactivateKey = async (domainName: string, apiKeyId: string) => {
        await this.post<void>(ApiRoutes.apiKey.deactivateApiKey({ domainName, apiKeyId }));
    };
}
